<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ reseller.name }} - {{ $t("COMMON.ORGANIZATIONS") }}
      </span>
    </div>

    <organization-list-table :filterReseller="reseller.id" />
  </div>
</template>

<script>
import OrganizationListTable from "../../OrganizationManagement/partials/OrganizationListTable.vue";
export default {
  name: "reseller-view-organizations",

  components: { OrganizationListTable },

  props: ["reseller"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    reseller(reseller) {},
  },
};
</script>
